module.exports = __webpack_public_path__ + "img/skoroBord.ddeb1864.png";